import tickIcon from '../../assets/images/tickGray.svg';
import { IconTextFace } from '../../utils/interfaces/planInterface';

export default function IconTextList({ items }: { items: IconTextFace[] }) {

    return (
        <div>
            {
                Array.isArray(items) && items.map(({ icon = tickIcon, text }, key) => {
                    return (
                        <div className='mb-3 flex items-start' key={key}>
                            {
                                typeof icon === 'string' ?
                                    <img src={icon} alt='Icon' className='inline me-3' />
                                    : icon
                            }
                            <p className='text-gray-500'>{text}</p>
                        </div>
                    )
                })
            }
        </div>
    )
}